import React from 'react';
import DatePicker from 'react-date-picker';
import UserDatapicker from '../classes/UserDatapicker';

import { connect } from 'react-redux';

import { Tooltip } from 'react-tippy';
import 'react-tippy/dist/tippy.css';

import { setUserInfo } from '../redux/actions/UserActions';

const userDatapicker = new UserDatapicker();

class Calendar extends React.PureComponent {

    componentDidMount() {
        // improve feature autofocus to next input during typing
        userDatapicker.customize();
    }

    onDateChange = date => {
        if (!date) return;
        // save date to Store for Estimation block
        this.props.dispatch(setUserInfo(date, this.props.unit));
        document.querySelector('.react-date-picker__button').classList.remove('error');
    }

    render() {
        return (
            <div className="datepicker">
                <div className="category-head">
                    <p>2) Child Birth month *</p>
                    <Tooltip
                        title="This helps us accurately estimate how long the bike will last, because kids grow at different rates depending on their age."
                        position="top"
                        trigger="mouseenter"
                    >
                        <div className="tooltip-ico">?</div>
                    </Tooltip>
                </div>
                <DatePicker
                    dateFormat="YYYY/MM/DD"
                    value={this.props.date}
                    onChange={date => this.onDateChange(date)}
                    maxDate={new Date()}
                    maxDetail='year'
                    view="year"
                    className="child-age"
                />
            </div>
        )
    }
}

// REDUX STATES
const mapStateToProps = state => {
    return {
        rangeValue: state.bike.rangeValue,
        date: state.user.date,
        unit: state.bike.unit,
        bike: state.bike.bike
    }
};

export default connect(mapStateToProps)(Calendar)


// WEBPACK FOOTER //
// ./src/components/Datepicker.js